import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const comentSlice = createSlice({
  name: "coment",
  initialState: { coment: "" },
  reducers: {
    setComentShow: (state, action) => {
      state.coment = action.payload;
    },
    setComentHide: (state) => {
      state.coment = "";
    },
  },
});

// Экшены
export const { setComentShow, setComentHide } = comentSlice.actions;

export default comentSlice.reducer;
